import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import { errorMessageNotification } from "../../../../helpers";
import moment from "moment";
// import { arrayMoveImmutable } from 'array-move';
import {
    arrayMove,
} from "react-sortable-hoc";
import { Row, Col, Segmented, Switch, Select, Tag, Button, Spin, notification as Notification, Modal } from "antd";
import ModalCalender from '../../components/ModalCalender';
import ModalMultiCalender from '../../components/ModalMultiCalender';
import TripEditPessenger from './TripEditPessenger';
import TripEditWhere from './TripEditWhere';
import TripEditOther from './TripEditOther';

const { confirm } = Modal;

const hours = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"]
const minutes = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]


class TripEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            form: {
                departureDate: moment(),
                departureHour: null,
                departureMinute: null,
                returnDate: moment(),
                returnHour: null,
                returnMinute: null,
                repeatedDates: [],
                passengers: [],
                vehicleTypeId: null,
                transferTypeId: null,
                note: null,
                routes: [
                ],
            },
            choiceType: "none",
            vehicleTypes: [],
            transferTypes: [],
            createOptions: null,
            theposition: 0,
            selectedMenu: "when",
            isModalCalenderOpen: false,
            isModalReturnCalenderOpen: false,
            isModalRepeatCalenderOpen: false,
            directionType: "oneWay",
            isRepeatDate: false,
            loadings: {
                createOptions: false,
                submit: false,
                data: false
            }


        };
        this.withWhoRef = React.createRef();
        this.whenRef = React.createRef();
        this.whereRef = React.createRef();
        this.otherRef = React.createRef();
    }

    componentDidMount() {
        window.addEventListener('scroll', this.listenToScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.listenToScroll)
    }

    componentWillMount() {
        this.getCreateOptions()
        this.getVehicleTypes()
        this.getTransferTypes()
    }

    getData = () => {

        let { loadings, directionType } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        let endpoint = { keyOne: "trip", idOne: this.props.match.params.id };

        this.props.dispatch(actions.definitions.getData({
            ...endpoint,
            filter: this.filter
        }))
            .then(response => {

                loadings.data = false;

                let form = {
                    departureDate: moment.parseZone(response.departureDate),
                    departureHour: moment.parseZone(response.departureDate).format("HH"),
                    departureMinute: moment.parseZone(response.departureDate).format("mm"),
                    returnDate: response.returnDate ? moment.parseZone(response.returnDate) : moment.parseZone(response.departureDate),
                    returnHour: response.returnDate ? moment.parseZone(response.returnDate).format("HH") : moment.parseZone(response.departureDate).format("HH"),
                    returnMinute: response.returnDate ? moment.parseZone(response.returnDate).format("mm") : moment.parseZone(response.departureDate).format("mm"),
                    repeatedDates: response.repeatedDates === "[]" ? [] : response.repeatedDates,
                    passengers: response.passengers,
                    vehicleTypeId: response.vehicleType.id,
                    transferTypeId: response.transferType.id,
                    note: response.note,
                    routes: response.routes,
                };

                if (response.returnDate) {
                    directionType = "roundTrip"
                }

                this.setState({ form: form, loadings, directionType })

            })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

            })
    }

    listenToScroll = () => {
        const winScroll =
            document.body.scrollTop || document.documentElement.scrollTop

        const height =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight

        const scrolled = winScroll / height

        this.setState({
            theposition: scrolled * 100,
        })



        const withWhoStart = this.whenRef.current.clientHeight + 25;
        const withWhoEnd = withWhoStart + this.withWhoRef.current.clientHeight;

        const whereStart = withWhoEnd + 25;
        const whereEnd = whereStart + this.whereRef.current.clientHeight;

        const otherStart = whereEnd + 25;
        const otherEnd = otherStart + this.otherRef.current.clientHeight;


        if (winScroll >= 0 && winScroll <= this.whenRef.current.clientHeight) {
            this.setState({
                selectedMenu: "when"
            })
        } else if (winScroll >= withWhoStart && winScroll <= withWhoEnd) {
            this.setState({
                selectedMenu: "withWho"
            })
        } else if (winScroll >= whereStart && winScroll <= whereEnd) {
            this.setState({
                selectedMenu: "where"
            })
        } else if (winScroll >= otherStart && winScroll <= otherEnd) {
            this.setState({
                selectedMenu: "other"
            })
        }

    }

    getVehicleTypes = () => {

        let endpoint = { keyOne: "trip/vehicletypes" };

        let { form } = this.state;

        this.props.dispatch(actions.definitions.getData({
            ...endpoint
        })).then(response => {

            if (!this.props.match.params.id) {
                form.vehicleTypeId = response[0].id;
            }

            this.setState({
                vehicleTypes: response, form
            });
        })
    }

    getTransferTypes = () => {

        let endpoint = { keyOne: "trip/transfertypes" };

        this.props.dispatch(actions.definitions.getData({
            ...endpoint
        })).then(response => {
            this.setState({
                transferTypes: response
            });
        })
    }

    getCreateOptions = () => {

        let endpoint = { keyOne: "trip/createoptions" };

        let { loadings, form } = this.state;
        loadings.createOptions = true;
        this.setState({ loadings })

        this.props.dispatch(actions.definitions.getData({
            ...endpoint
        })).then(response => {

            // form.departureDate = moment(response.minDepartureDate).add(-1, 'days');
            form.departureDate = moment(response.minDepartureDate);
            form.returnDate = moment(response.minDepartureDate);
            form.departureHour = this.onDefaultHour(response);
            form.departureMinute = minutes[0];
            form.returnHour = this.onDefaultHour(response);
            form.returnMinute = minutes[0];

            // response.minDepartureDate =  moment(response.minDepartureDate).add(-1, 'days')

            loadings.createOptions = false;

            this.setState({
                createOptions: response, form, loadings
            }, () => {
                if (this.props.match.params.id) {
                    this.getData()
                }
            });
        })
    }

    onToggleDepartureDatePicker = () => {
        this.setState({ isModalCalenderOpen: !this.state.isModalCalenderOpen });
    }

    onToggleReturnDatePicker = () => {
        this.setState({ isModalReturnCalenderOpen: !this.state.isModalReturnCalenderOpen });
    }

    onToggleRepeatDatePicker = () => {
        this.setState({ isModalRepeatCalenderOpen: !this.state.isModalRepeatCalenderOpen });
    }

    onSelectDepartureDate = (date) => {

        let { form } = this.state;
        form.departureDate = date;

        if (form.departureDate > form.returnDate) {
            form.returnDate = form.departureDate;
        }
        this.setState({ form: form });
        this.onToggleDepartureDatePicker()

    }

    onSelectReturnDate = (date) => {

        let { form } = this.state;
        form.returnDate = date;
        this.setState({ form: form });
        this.onToggleReturnDatePicker()

    }

    onSelectRepeatDate = (selectedDates) => {
        let { form } = this.state;
        form.repeatedDates = selectedDates;
        this.setState({ form: form });

        this.onToggleRepeatDatePicker();

    }

    onChangeSegmented = (value) => {
        this.setState({ directionType: value })
    }

    onRemoveRepeatDate = (date) => {

        let { form } = this.state;
        form.repeatedDates = form.repeatedDates.filter(e => e !== date);
        this.setState({ form });

    }

    onChangeRepeatDate = (value) => {
        this.setState({ isRepeatDate: value })
    }

    onSelectTime = (type, value) => {

        let { form } = this.state;
        form[type] = value;

        this.setState({ form })

    }

    scrollToModule = (module) => {

        const withWhoStart = this.whenRef.current.clientHeight + 25;
        const withWhoEnd = withWhoStart + this.withWhoRef.current.clientHeight;

        const whereStart = withWhoEnd + 25;
        const whereEnd = whereStart + this.whereRef.current.clientHeight;

        const otherStart = whereEnd + 25;


        if (module === "when") {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else if (module === "withWho") {
            window.scrollTo({ top: withWhoStart, behavior: 'smooth' });
        } else if (module === "where") {
            window.scrollTo({ top: whereStart, behavior: 'smooth' });
        } else if (module === "other") {
            window.scrollTo({ top: otherStart, behavior: 'smooth' });
        }

    }

    addPassenger = (item) => {

        let { form, vehicleTypes } = this.state;
        let newVehicleTypeId = null;

        if (form.passengers.some(e => e.phoneNumber === item.phoneNumber)) {
            form.passengers = form.passengers.filter(e => e.phoneNumber !== item.phoneNumber)
        } else {
            form.passengers.push(item);
        }

        var filteredVehicleTypes = vehicleTypes.filter(x => x.capacity >= form.passengers.length)
        if (filteredVehicleTypes.length > 0) {
            newVehicleTypeId = filteredVehicleTypes[0].id
        }
        form.vehicleTypeId = newVehicleTypeId;

        this.setState({ form })

    }

    changePassengerContact = (item) => {

        let { form } = this.state;
        var newPassengers = [];

        form.passengers.forEach((passenger) => {
            if (passenger.phoneNumber === item.phoneNumber) {
                passenger.isContact = true;
            } else {
                passenger.isContact = false;
            }

            newPassengers.push(passenger)
        })

        form.passengers = newPassengers;

        this.setState({ form })

    }

    changePassenger = (item) => {

        let { form } = this.state;

        let newPassengers = [];

        form.passengers.forEach((passenger) => {

            if (passenger.phoneNumber === item.phoneNumber) {
                passenger.name = item.name;
                passenger.lastname = item.lastname;
                passenger.email = item.email;
            }
            newPassengers.push(passenger)
        })

        form.passengers = newPassengers;

        this.setState({ form })

    }

    onSelectVehicleType = (item) => {

        let { form } = this.state;
        form.vehicleTypeId = item.id;
        this.setState({ form })

    }


    addRoute = (item, selectedIndex) => {

        let { form } = this.state;

        if (item.type === "StartPoint") {
            form.routes = form.routes.filter(x => x.type !== "StartPoint");
            form.routes.push(item)
            this.setState({ form })
        }

        if (item.type === "EndPoint") {
            form.routes = form.routes.filter(x => x.type !== "EndPoint");
            form.routes.push(item)
            this.setState({ form })
        }

        if (item.type === "WayPoint") {

            if (selectedIndex !== undefined && selectedIndex >= 0) {
                let wayPoints = form.routes.filter(x => x.type === "WayPoint");
                wayPoints[selectedIndex] = item;

                form.routes = form.routes.filter(x => x.type !== "WayPoint");

                wayPoints.forEach((item) => {
                    form.routes.push(item)
                })
                this.setState({ form })

            } else {
                form.routes.push(item)
                this.setState({ form })
            }
        }

    }

    deleteWayPoint = (index) => {

        let { form } = this.state;
        let wayPoints = form.routes.filter(x => x.type === "WayPoint");

        delete wayPoints[index];

        form.routes = form.routes.filter(x => x.type !== "WayPoint");

        wayPoints.forEach((item) => {
            form.routes.push(item)
        })

        this.setState({ form })

    }

    moveWayPoint = (oldIndex, newIndex) => {

        let { form } = this.state;
        let wayPoints = form.routes.filter(x => x.type === "WayPoint");
        const sortedWayPoints = arrayMove(wayPoints.slice(), oldIndex, newIndex).filter(
            (el) => !!el,
        );
        form.routes = form.routes.filter(x => x.type !== "WayPoint");

        sortedWayPoints.forEach((item) => {
            form.routes.push(item)
        })

        this.setState({ form })

    }

    renderHours = (type) => {

        let { createOptions, form } = this.state;

        if (type === "departure") {
            if (moment(createOptions.minDepartureDate).date() === form.departureDate.date()) {
                return hours.filter(x => x >= moment(createOptions.minDepartureDate).hour())
            } else {
                return hours;
            }
        } else {
            if (moment(createOptions.minDepartureDate).date() === form.returnDate.date()) {
                return hours.filter(x => x >= moment(createOptions.minDepartureDate).hour())
            } else {
                return hours;
            }
        }


    }

    onDefaultHour = (createOptions) => {

        let { form } = this.state;

        if (moment(createOptions.minDepartureDate).date() === form.departureDate.date()) {
            return hours.filter(x => x >= moment(createOptions.minDepartureDate).hour())[0]
        } else {
            return hours[0];
        }
    }

    renderMinutes = () => {

        let { createOptions, form } = this.state;

        if (moment(createOptions.minDepartureDate).date() === form.departureDate.date()) {
            return minutes.filter(x => x > moment(createOptions.minDepartureDate).minutes())
        } else {
            return minutes;
        }
    }

    onSelectTransferType = (value) => {

        let { form } = this.state;
        form.transferTypeId = value;
        this.setState({ form })

    }

    onChangeNote = (e) => {

        let { form } = this.state;
        form.note = e.target.value;
        this.setState({ form })

    }

    fetchTrip = () => {

        let endpoint = { keyOne: "trip" };

        let { form, loadings, directionType, choiceType } = this.state;

        // let departureDate = form.departureDate.set("hour", form.departureHour).set("minute", form.departureMinute);
        let departureDate = moment(form.departureDate).hour(form.departureHour).minute(form.departureMinute).format('YYYY-MM-DD HH:mm:ss');
        let returnDate = moment(form.returnDate).hour(form.returnHour).minute(form.returnMinute).format('YYYY-MM-DD HH:mm:ss');
        // let returnDate = form.returnDate.set("hour", form.returnHour).set("minute", form.returnMinute);

        debugger

        var param = {
            departureDate: departureDate,
            returnDate: directionType === "roundTrip" ? returnDate : null,
            repeatedDates: form.repeatedDates,
            passengers: form.passengers,
            vehicleTypeId: form.vehicleTypeId,
            transferTypeId: form.transferTypeId === null ? 0 : form.transferTypeId,
            note: form.note,
            routes: form.routes
        }

        loadings.submit = true;
        this.setState({ loadings });

        let method = "addData"
        let filter = null;

        if (this.props.match.params.id) {
            method = "updateData";
            endpoint = { keyOne: "trip", idOne: this.props.match.params.id };

        } else {
            filter = {
                choiceType: choiceType
            }
        }

        this.props
            .dispatch(
                actions.definitions[method]({
                    ...endpoint,
                    data: param,
                    filter: filter

                })
            )
            .then(() => {

                Notification.success({
                    message: "Tebrikler!",
                    description: method === "updateData" ? "Talebiniz başarılı bir şekilde güncellendi." : "Talebiniz başarılı bir şekilde oluşturuldu.",
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 5,
                });

                this.props.history.push(
                    `/app/trips`
                );

            })
            .catch(error => {
                
                console.log("error.status",error)

                loadings.submit = false;
                this.setState({ loadings });

                if (error.type === "Split") {
                    this.onSeperateConfirm(errorMessageNotification(error))
                } else {
                    Notification.error({
                        message: i18n.t(`error`, {
                            lng: this.props.currentLanguage,
                        }),
                        description: errorMessageNotification(error),
                        className: "general-notification",
                        placement: "bottomLeft",
                        duration: 100,
                    });

                    setTimeout(() => {
                        Notification.destroy();
                    }, 3000);
                }

            })
    };

    onSeperateConfirm = (message) => {

        let _this = this;

        confirm({
            centered: true,
            title: 'Uyarı',
            content: message,
            okText: "Talebi ikiye böl",
            cancelText: "Bölme",
            onOk() {
                _this.setState({
                    choiceType: "split"
                }, () => {
                    _this.fetchTrip()
                });

            },
            onCancel() {
                _this.setState({
                    choiceType: "noAction"
                }, () => {
                    _this.fetchTrip()
                });
            },
        });

    }

    render() {

        let {
            form,
            selectedMenu,
            isModalCalenderOpen,
            isModalReturnCalenderOpen,
            isModalRepeatCalenderOpen,
            directionType,
            isRepeatDate,
            vehicleTypes,
            createOptions,
            loadings,
            transferTypes
        } = this.state;

        return (

            <Fragment>

                {
                    loadings.createOptions &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`Hazırlanıyor, lütfen bekleyiniz...`}
                        />
                    </div>
                }

                {
                    !loadings.createOptions &&
                    <div className="trip-edit-container">
                        <Row>
                            <Col xs={4} sm={4} md={4} lg={4} xl={4} className='menu-sidebar'>
                                <ul>
                                    <li>
                                        <a className={selectedMenu === `when` ? `menu-item active` : `menu-item`} onClick={(e) => this.scrollToModule("when")}>
                                            <i className="fa fa-clock-o" aria-hidden="true">
                                            </i>
                                        </a>
                                    </li>
                                    <li>
                                        <a className={selectedMenu === `withWho` ? `menu-item active` : `menu-item`} onClick={(e) => this.scrollToModule("withWho")}>
                                            <i className="fa fa-user-plus" aria-hidden="true">

                                            </i>
                                        </a>
                                    </li>
                                    <li>
                                        <a className={selectedMenu === `where` ? `menu-item active` : `menu-item`} onClick={(e) => this.scrollToModule("where")}>
                                            <i className="fa fa-map-marker" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a className={selectedMenu === `other` ? `menu-item active` : `menu-item`} onClick={(e) => this.scrollToModule("other")}>
                                            <i className="fa fa-comment-o" aria-hidden="true">

                                            </i>
                                        </a>
                                    </li>
                                </ul>
                            </Col>
                            <Col xs={20} sm={20} md={20} lg={20} xl={20} className='content-container'>

                                <div className='content-box when' ref={this.whenRef}>
                                    <div className='module'>NE ZAMAN?</div>
                                    <Segmented block options={
                                        [
                                            {
                                                value: "oneWay",
                                                label: "TEK YÖN"
                                            },
                                            {
                                                value: "roundTrip",
                                                label: "GİDİŞ / DÖNÜŞ"
                                            }
                                        ]
                                    }
                                        onChange={(e) => this.onChangeSegmented(e)}
                                        value={directionType}
                                    />

                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <div className='label'>
                                                <img src="../../../assets/img/icons/departure-date-icon.png" alt="" />
                                                <span>
                                                    GİDİŞ TARİHİ
                                                </span>
                                            </div>

                                            <div className="box-with-icon"
                                                onClick={() => this.onToggleDepartureDatePicker()}
                                            >
                                                <div className='date'>{moment.parseZone(form.departureDate).format('LL')}</div>
                                                <span className='date-name'>{moment.parseZone(form.departureDate).format('dddd')}</span>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <div className='label'>
                                                <img src="../../../assets/img/icons/departure-date-icon.png" alt="" />
                                                <span>
                                                    GİDİŞ SAATİ
                                                </span>
                                            </div>
                                            <Row>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <div className="box-with-icon-withtime" style={{ marginLeft: 5 }}>
                                                        <Select
                                                            className='ant-select-time'
                                                            defaultValue={form.departureHour}
                                                            value={form.departureHour}
                                                            bordered={false}
                                                            onSelect={(value) => this.onSelectTime("departureHour", value)}
                                                            options={this.renderHours("departure").map((item) => {
                                                                return {
                                                                    value: item,
                                                                    label: item,
                                                                }
                                                            })}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <div className="box-with-icon-withtime" style={{ marginLeft: 5 }}>
                                                        <Select
                                                            className='ant-select-time'
                                                            defaultValue={form.departureMinute}
                                                            value={form.departureMinute}
                                                            bordered={false}
                                                            onSelect={(value) => this.onSelectTime("departureMinute", value)}
                                                            options={this.renderMinutes().map((item) => {
                                                                return {
                                                                    value: item,
                                                                    label: item,
                                                                }
                                                            })}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    {
                                        directionType === "roundTrip" &&

                                        <Row>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <div className='label'>
                                                    <img src="../../../assets/img/icons/departure-date-icon.png" alt="" />
                                                    <span>
                                                        DÖNÜŞ TARİHİ
                                                    </span>
                                                </div>

                                                <div className="box-with-icon"
                                                    onClick={() => this.onToggleReturnDatePicker()}
                                                >
                                                    <div className='date'>{moment(form.returnDate).format('LL')}</div>
                                                    <span className='date-name'>{moment(form.returnDate).format('dddd')}</span>
                                                </div>


                                            </Col>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <div className='label'>
                                                    <img src="../../../assets/img/icons/departure-date-icon.png" alt="" />
                                                    <span>
                                                        DÖNÜŞ SAATİ
                                                    </span>
                                                </div>
                                                <Row>
                                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <div className="box-with-icon-withtime" style={{ marginLeft: 5 }}>
                                                            <Select
                                                                className='ant-select-time'
                                                                defaultValue={form.returnHour}
                                                                bordered={false}
                                                                onSelect={(value) => this.onSelectTime("returnHour", value)}
                                                                options={this.renderHours("return").map((item) => {
                                                                    return {
                                                                        value: item,
                                                                        label: item,
                                                                    }
                                                                })}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <div className="box-with-icon-withtime" style={{ marginLeft: 5 }}>
                                                            <Select
                                                                className='ant-select-time'
                                                                defaultValue={form.returnMinute}
                                                                bordered={false}
                                                                onSelect={(value) => this.onSelectTime("returnMinute", value)}
                                                                options={this.renderMinutes().map((item) => {
                                                                    return {
                                                                        value: item,
                                                                        label: item,
                                                                    }
                                                                })}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    }
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <div className='label red'>
                                                <Switch defaultChecked onChange={(e) => this.onChangeRepeatDate(e)} checked={isRepeatDate} />
                                                <span>
                                                    TEKRARLI TALEP
                                                </span>
                                            </div>
                                        </Col>
                                    </Row>

                                    {
                                        isRepeatDate &&
                                        <Row>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <div className='repeat-dates' onClick={(e) => this.onToggleRepeatDatePicker()}>
                                                    {
                                                        form.repeatedDates.length > 0 ?
                                                            form.repeatedDates.map(date => {
                                                                return <Tag onClose={(e) => this.onRemoveRepeatDate(date)} closable>{moment(date).format('DD.MM.YYYY')}</Tag>
                                                            })
                                                            :
                                                            <span className='placeholder'>Lütfen tekrarlamak istediğiniz günleri seçiniz...</span>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Button
                                                htmlType="submit"
                                                type="primary"
                                                className="ant-btn width-100"
                                                style={{ float: "right", height: 40, marginTop: 25 }}
                                                onClick={(e) => this.scrollToModule("withWho")}
                                            >
                                                Devam
                                            </Button>
                                        </Col>
                                    </Row>


                                </div>

                                <div className='content-box witwho' ref={this.withWhoRef}>
                                    <TripEditPessenger
                                        scrollToModule={this.scrollToModule}
                                        passengers={form.passengers}
                                        addPassenger={this.addPassenger}
                                        // deletePassenger={this.deletePassenger}
                                        form={form}
                                        changePassengerContact={this.changePassengerContact}
                                        changePassenger={this.changePassenger}
                                        vehicleTypeId={form.vehicleTypeId}
                                        onSelectVehicleType={this.onSelectVehicleType}
                                        vehicleTypes={vehicleTypes}
                                        id={this.props.match.params.id}
                                    />
                                </div>

                                <div className='content-box where' ref={this.whereRef}>
                                    <TripEditWhere
                                        scrollToModule={this.scrollToModule}
                                        addRoute={this.addRoute}
                                        routes={form.routes}
                                        moveWayPoint={this.moveWayPoint}
                                        deleteWayPoint={this.deleteWayPoint}
                                    />
                                </div>
                                <div className='content-box other' ref={this.otherRef} style={{ marginBottom: 225 }}>
                                    <TripEditOther
                                        scrollToModule={this.scrollToModule}
                                        onSelectTransferType={this.onSelectTransferType}
                                        transferTypeId={form.transferTypeId}
                                        transferTypes={transferTypes}
                                        onChangeNote={this.onChangeNote}
                                        note={form.note}
                                        fetchTrip={this.fetchTrip}
                                        loadingSubmit={loadings.submit}
                                        id={this.props.match.params.id}
                                    />
                                </div>

                            </Col>
                        </Row>

                        <ModalCalender
                            isModalOpen={isModalCalenderOpen}
                            onSelect={this.onSelectDepartureDate}
                            handleCancel={this.onToggleDepartureDatePicker}
                            handleOk={this.onToggleDepartureDatePicker}
                            createOptions={createOptions}
                            date={form.departureDate}
                        />

                        <ModalCalender
                            isModalOpen={isModalReturnCalenderOpen}
                            onSelect={this.onSelectReturnDate}
                            handleCancel={this.onToggleReturnDatePicker}
                            handleOk={this.onToggleReturnDatePicker}
                            createOptions={createOptions}
                            date={form.returnDate}
                        />

                        <ModalMultiCalender
                            isModalOpen={isModalRepeatCalenderOpen}
                            onSelect={this.onSelectRepeatDate}
                            handleCancel={this.onToggleRepeatDatePicker}
                            handleOk={this.onToggleRepeatDatePicker}
                            defaultValues={form.repeatedDates}
                            createOptions={createOptions}
                            date={form.departureDate}
                        />


                    </div>
                }

            </Fragment>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripEdit);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripEdit.js